








































import { Vue, Component, Prop } from 'vue-property-decorator'
import { api } from '../../api';
import { AxiosError } from 'axios';
import { UNPROCESSABLE_ENTITY } from 'http-status-codes';
import { validPassword } from '../../utils/validation';

@Component
export default class extends Vue {
  currentPassword = ''
  password = ''
  passwordAgain = ''
  validateAlways = false

  @Prop({ required: true })
  show!: boolean

  focus() {
    (this.$refs.currentPassword as HTMLInputElement).focus()
  }

  async submit() {
    if (!this.ok) {
      (this.$refs.dialog as any).shake(() => this.validateAlways = true)
      return
    }

    const axios = api.passErrors(UNPROCESSABLE_ENTITY)
    try {
      const current_password = this.currentPassword
      const new_password = this.password
      await axios.put('../api/v1/user/password', {
        current_password,
        new_password,
      })
      this.close()
      alert(this.$t('password_changed'))
    } catch (e) {
      const error: AxiosError = e
      switch (error.response!.status) {
        case UNPROCESSABLE_ENTITY:
          alert(this.$t('incorrect_password'))
          break
      }
    }
  }

  get ok() {
    return this.passwordErrors.length + this.passwordAgainErrors.length === 0
  }

  private reset() {
    this.validateAlways = false
    this.currentPassword = ''
    this.password = ''
    this.passwordAgain = ''
  }

  close() {
    this.reset()
    this.$emit('update:show', false)
  }

  get passwordErrors() {
    return [!validPassword(this.password) && this.$t('must_be_length_of_at_least_8')].filter((e) => e)
  }

  get passwordAgainErrors() {
    return [this.password !== this.passwordAgain && this.$t('do_not_match')].filter((e) => e)
  }
}
